<header class="site-header">
  <a routerLink="/home" class="site-header__brand">
    <span class="site-header__logo" aria-hidden="true">M</span>
    <span class="site-header__brand-name">{{ 'common.brandName' | translate }}</span>
  </a>

  <nav class="site-header__nav" aria-label="Main navigation">
    @for (link of navLinks; track link.route) {
      <a [routerLink]="link.route" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: link.route === '/home' || link.route === '/rooms' || link.route === '/about' || link.route === '/reviews' || link.route === '/contact' }">
        {{ link.labelKey | translate }}
      </a>
    }
  </nav>

  <div class="site-header__actions">
    <app-language-switcher hostClass="site-header__locale" buttonClass="site-header__locale" />

    <a class="site-header__phone" [href]="phoneHref">
      <svg class="site-header__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
      <span>{{ phone }}</span>
    </a>

    @if (!authService.isAuthenticated()) {
      <a routerLink="/login" class="site-header__sign-in">{{ 'common.signIn' | translate }}</a>
    }

    <a routerLink="/book" class="site-header__cta">{{ 'common.bookNow' | translate }}</a>

    @if (authService.isAuthenticated()) {
      @if (currentUser$ | async; as user) {
        <div class="site-header__user-menu">
          <button
            type="button"
            class="site-header__avatar"
            [attr.aria-expanded]="isUserMenuOpen"
            aria-haspopup="true"
            [attr.aria-label]="'common.userMenu' | translate"
            (click)="toggleUserMenu($event)"
          >
            {{ getUserInitials(user.name) }}
          </button>

          @if (isUserMenuOpen) {
            <div class="site-header__dropdown" role="menu">
              <div class="site-header__dropdown-user">
                <p class="site-header__dropdown-name">{{ user.name }}</p>
                <p class="site-header__dropdown-email">{{ user.email }}</p>
              </div>

              <nav class="site-header__dropdown-nav" aria-label="User menu">
                <a routerLink="/profile" class="site-header__dropdown-item" role="menuitem" (click)="closeUserMenu()">
                  <svg class="site-header__dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  {{ 'common.profile' | translate }}
                </a>
                <a routerLink="/my-bookings" class="site-header__dropdown-item" role="menuitem" (click)="closeUserMenu()">
                  <svg class="site-header__dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                  {{ 'common.myBookings' | translate }}
                </a>
                <a routerLink="/contact" class="site-header__dropdown-item" role="menuitem" (click)="closeUserMenu()">
                  <svg class="site-header__dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                  {{ 'common.helpContact' | translate }}
                </a>
              </nav>

              <button
                type="button"
                class="site-header__dropdown-sign-out"
                role="menuitem"
                [disabled]="isLoggingOut"
                (click)="logout()"
              >
                <svg class="site-header__dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                {{ (isLoggingOut ? 'common.signingOut' : 'common.signOut') | translate }}
              </button>
            </div>
          }
        </div>
      }
    }
  </div>
</header>
